const array = (...args: unknown[]): unknown[] => {
  return Array.prototype.slice.call(args, 0, -1);
};

export default array;
